// extracted by mini-css-extract-plugin
export default {"base":"MainNavigationItem_base__u89hX","active":"MainNavigationItem_active__y3-QK"};